// API/notaPengiriman.js
import axios from '../../api';

const BASE = process.env.REACT_APP_URL || 'http://localhost:5100';

export const getBantuanForNota = () => {
  return axios.get(`${BASE}/nota-pengiriman/bantuan-supplier`)
    .then(response => {
      console.log('=== getBantuanForNota Response ===');
      console.log('Full response:', response);
      console.log('Response data:', response.data);
      console.log('Data array:', response.data?.data);
      return response;
    })
    .catch(error => {
      console.error('Error getBantuanForNota:', error);
      throw error;
    });
};

export const getNotaById = (id) =>
  axios.get(`${BASE}/nota-pengiriman/${id}`);

export const getNotaList = (params = {}) => {
  return axios.get(`${BASE}/nota-pengiriman`, { params })
    .then(response => {
      console.log('=== getNotaList Response ===');
      console.log('Response:', response);
      return response;
    })
    .catch(error => {
      console.error('Error getNotaList:', error);
      throw error;
    });
};

export const createNota = (formData) => {
  return axios.post(`${BASE}/nota-pengiriman`, formData, { 
    headers: { 'Content-Type': 'multipart/form-data' } 
  });
};

export const verifyNota = (id, { status }) => {
  return axios.put(`${BASE}/nota-pengiriman/${id}/verify`, { status });
};

export const deleteNota = (id) => {
  return axios.delete(`${BASE}/nota-pengiriman/${id}`);
};